import React from "react";
import "./Headline.scss";

export const Headline = () => {
  return (
    <div className="text-light text-center text-md-left">
      <h1 className="home__main-title main-title font-weight-bold">
        Software para Clínicas e Profissionais de Saúde
      </h1>
      <h2 className="home__main-subtitle main-subtitle mb-3">
        O Prontuário Inteligente integrado à Telemedicina e Prescrição Digital
        que economiza seu tempo
      </h2>
    </div>
  );
};
